export default __webpack_public_path__ + "static/media/yellowTheme-boy.7c51b8f9.svg";